import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './WantItDelivered.styles';
var PROP_TYPES = {
  handleClick: PropTypes.func
};

var WantItDelivered = function WantItDelivered(_ref) {
  var handleClick = _ref.handleClick,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(Styled.StyledContainer, null, /*#__PURE__*/React.createElement(Styled.StyledButton, {
    onClick: function onClick(event) {
      return handleClick(event, null, true, null);
    },
    kind: "link",
    full: true,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(Styled.StyledTwoManDeliveryIcon, null), /*#__PURE__*/React.createElement("span", null, "Want it delivered?")));
};

WantItDelivered.propTypes = PROP_TYPES;
WantItDelivered.defaultProps = {
  'data-test': 'want-it-delivered-button'
};
export default WantItDelivered;